module.exports = __webpack_public_path__ + "img/CS-ECONew_Overview-EVA_1.06276b7e.jpg";